<mat-card class="h-full">
    <mat-card-header>
        <h2 class="heading-small">
            {{ cardTitle }} ({{ notifications().length }})
        </h2>
    </mat-card-header>
    <mat-card-content class="p-4">
        @if (notifications() === null || notifications().length === 0) {
            <!-- No notifications available -->
            {{ 'shared.notificationReader.noNotifications' | translate }}
        } @else {
            @for (
                notification of notifications()
                    | slice: 0 : numOfNotificationsToDisplay;
                track notification.id
            ) {
                <div>
                    <strong>
                        {{ 'shared.notificationReader.createdAt' | translate }}
                        {{ notification.createdAt | translateDate }}
                    </strong>
                    <p>{{ notification.message }}</p>
                    <div class="my-4">
                        <mat-divider />
                    </div>
                </div>
            }
            @if (notifications().length > numOfNotificationsToDisplay) {
                <button
                    mat-flat-button
                    color="primary"
                    attr.aria-label="{{
                        'shared.notificationReader.viewAllBtnLabel' | translate
                    }}"
                    (click)="openNotificationsDialog()">
                    {{ 'shared.notificationReader.viewAll' | translate }}
                </button>
            }
        }
    </mat-card-content>
</mat-card>
